<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: ['data', 'options', 'colors', 'labels', 'max'],
  data () {
    return {
      defaultOptions: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: this.max || 100
              }
            }
          ]
        }
      },
      defaultData: {
        labels: '',
        datasets: [
          {
            label: '',
            backgroundColor: this.colors || [],
            data: []
          }
        ]
      }
    }
  },
  mounted () {
    if (this.data) this.defaultData.datasets[0].data = this.data
    this.defaultData.labels = this.labels

    this.renderChart(this.defaultData, this.options || this.defaultOptions)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/share/HorizontalBarChart.vue